<template>
  <jczh-drawer
    :visible.sync="drawerVisible"
    title="选择供应商"
    confirm-button-text="确定"
    size="800px"
    :el-attrs="{
      destroyOnClose: true
    }"
    @close="handleDrawerClose"
    @confirm="handleConfirm"
  >
    <template slot="content">
      <div>
        <div v-if="selectionRow.length > 0" class="m-v-20">
          <span>已选供应商({{ selectionRow.length }})：</span>
          <el-tag
            v-for="(item, index) in selectionRow"
            :key="item.companyId"
            type="primary"
            closable
            class="m-t-10 m-r-10"
            @close="handleTagClose(item, index)"
          >
            {{ item.companyName }}
          </el-tag>
        </div>

        <el-tabs v-model="activeName" stretch @tab-click="handleTabClick">
          <el-tab-pane v-if="isWl" label="企业供应商" name="company">
            <company-supplier-filter-table
              ref="companyTable"
              :selected="selectionRow"
              :disabled-array="disabledArray"
              @selectionChange="handleCompanySelectionChange"
            />
          </el-tab-pane>
          <el-tab-pane label="平台供应商" name="platform">
            <platform-supplier-filter-table
              ref="platformTable"
              :selected="selectionRow"
              :disabled-array="disabledArray"
              @selectionChange="handlePlatformSelectionChange"
            />
          </el-tab-pane>
          <el-tab-pane
            v-if="companySupplierShow"
            :label="supplierTitleList[0]"
            name="company"
          >
            <company-supplier-filter-table
              ref="companyTable"
              :selected="selectionRow"
              :is-agency="isAgency"
              :is-allow-use-srm="isAllowUseSrm"
              :purchase-company-id="purchaseCompanyId"
              :disabled-array="disabledArray"
              @selectionChange="handleCompanySelectionChange"
            />
          </el-tab-pane>
          <el-tab-pane
            v-if="companySupplierShareShow"
            :label="supplierTitleList[1]"
            name="share"
          >
            <share-supplier-filter-table
              ref="shareTable"
              :selected="selectionRow"
              :is-agency="isAgency"
              :is-allow-use-srm="isAllowUseSrm"
              :purchase-company-id="purchaseCompanyId"
              :disabled-array="disabledArray"
              @selectionChange="handleShareSelectionChange"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
    <template slot="footer">
      <div style="width: 100%">
        <el-button style="width: 60px" @click="handleDrawerClose">
          取消
        </el-button>
        <el-button style="width: 60px" type="primary" @click="handleConfirm">
          确定
        </el-button>
      </div>
    </template>
  </jczh-drawer>
</template>

<script>
import PlatformSupplierFilterTable from '@/components/common/SelectSupplierDrawer/PlatformSupplierFilterTable'
import CompanySupplierFilterTable from '@/components/common/SelectSupplierDrawer/CompanySupplierFilterTable'
import ShareSupplierFilterTable from '@/components/common/SelectSupplierDrawer/ShareSupplierFilterTable'
import { unique } from '@/utils/utils'
import { cloneDeep } from 'lodash'

export default {
  name: 'SelectSupplierDrawer',

  components: {
    PlatformSupplierFilterTable,
    CompanySupplierFilterTable,
    ShareSupplierFilterTable
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    selected: {
      type: Array,
      default: () => []
    },

    // 数据传入转换函数
    normalizeIn: {
      type: Function,
      default: list => {
        return list
      }
    },

    // 数据传出专函函数
    normalizeOut: {
      type: Function,
      default: list => {
        return list
      }
    },

    disabledArray: {
      type: Array,
      default: () => []
    },

    // 是否是五菱
    isWl: {
      type: Boolean,
      default: false
    },

    // 是否单选
    isSingle: {
      type: Boolean,
      default: false
    },

    isAgency: {
      type: Boolean,
      default: false
    },

    // 采购人公司id
    purchaseCompanyId: {
      type: [String, Number],
      default: ''
    },

    // 是否授权代理机构使用供应商库
    isAllowUseSrm: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      activeName: 'platform',
      selectionRow: [],
      platformSelectionRow: [],
      companySelectionRow: [],
      shareSelectionRow: []
    }
  },

  computed: {
    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    // 非五菱供应商库
    companySupplierShow() {
      // 代理机构需供应商授权才能使用
      if (this.isAgency) {
        return !this.isWl && this.isAllowUseSrm
      } else {
        return !this.isWl
      }
    },
    // 共享供应商库
    companySupplierShareShow() {
      // 代理机构需供应商授权才能使用
      if (this.isAgency) {
        return this.isAllowUseSrm
      } else {
        return true
      }
    },
    supplierTitleList() {
      return this.isAgency
        ? ['委托单位供应商库', '委托单位共享供应商库']
        : ['企业供应商', '共享供应商']
    }
  },

  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.selectionRow = cloneDeep(this.selected)
        }
      },
      immediate: true
    },

    isWl: {
      handler(val) {
        if (val) {
          this.activeName = 'company'
        }
      },
      immediate: true
    },

    platformSelectionRow(newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        // 取差集
        const difference = [...oldVal].filter(x =>
          [...newVal].every(y => y.companyId !== x.companyId)
        )

        // 删减情况下，从合集中剔除差集
        difference.forEach(item => {
          const index = this.companySelectionRow.findIndex(
            row => row.companyId === item.companyId
          )
          if (index > -1) this.companySelectionRow.splice(index, 1)

          const index2 = this.shareSelectionRow.findIndex(
            row => row.companyId === item.companyId
          )
          if (index2 > -1) this.shareSelectionRow.splice(index2, 1)
        })
      }
      this.selectionRow = newVal
        .concat(this.companySelectionRow)
        .concat(this.shareSelectionRow)
      this.selectionRow = unique(this.selectionRow, 'companyId')
    },

    companySelectionRow(newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        // 取差集
        const difference = [...oldVal].filter(x =>
          [...newVal].every(y => y.companyId !== x.companyId)
        )

        // 删减情况下，从合集中剔除差集
        difference.forEach(item => {
          const index = this.platformSelectionRow.findIndex(
            row => row.companyId === item.companyId
          )
          if (index > -1) this.platformSelectionRow.splice(index, 1)

          const index2 = this.shareSelectionRow.findIndex(
            row => row.companyId === item.companyId
          )
          if (index2 > -1) this.shareSelectionRow.splice(index2, 1)
        })
      }

      this.selectionRow = newVal
        .concat(this.platformSelectionRow)
        .concat(this.shareSelectionRow)
      this.selectionRow = unique(this.selectionRow, 'companyId')
    },

    shareSelectionRow(newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        // 取差集
        const difference = [...oldVal].filter(x =>
          [...newVal].every(y => y.companyId !== x.companyId)
        )

        // 删减情况下，从合集中剔除差集
        difference.forEach(item => {
          const index = this.platformSelectionRow.findIndex(
            row => row.companyId === item.companyId
          )
          if (index > -1) this.platformSelectionRow.splice(index, 1)

          const index2 = this.companySelectionRow.findIndex(
            row => row.companyId === item.companyId
          )
          if (index2 > -1) this.companySelectionRow.splice(index2, 1)
        })
      }

      this.selectionRow = newVal
        .concat(this.platformSelectionRow)
        .concat(this.companySelectionRow)
      this.selectionRow = unique(this.selectionRow, 'companyId')
    }
  },

  methods: {
    handleTabClick() {},

    handleDrawerClose() {
      this.drawerVisible = false
      this.selectionRow = []
    },

    handleConfirm() {
      if (this.isSingle) {
        if (this.selectionRow.length > 1) {
          this.$message.warning('只能选择一个供应商')
          return
        }
      }
      this.drawerVisible = false
      this.$emit('confirmed', this.selectionRow)
    },

    handlePlatformSelectionChange(selection) {
      this.platformSelectionRow = selection.map(item => {
        return {
          companyId: item.companyId,
          companyName: item.companyName,
          contactTel: item.contactTel,
          contactName: item.contactName
        }
      })
    },

    handleTagClose(row, index) {
      this.selectionRow.splice(index, 1)
      const platformIndex = this.platformSelectionRow.findIndex(
        item => item.companyId === row.companyId
      )
      this.platformSelectionRow.splice(platformIndex, 1)
      const companyIndex = this.companySelectionRow.findIndex(
        item => item.companyId === row.companyId
      )
      this.companySelectionRow.splice(companyIndex, 1)
      const shareIndex = this.shareSelectionRow.findIndex(
        item => item.companyId === row.companyId
      )
      this.shareSelectionRow.splice(shareIndex, 1)
    },

    handleCompanySelectionChange(selection) {
      this.companySelectionRow = selection.map(item => {
        return {
          companyId: item.supplierId || item.companyId,
          companyName: item.supplierName || item.companyName,
          contactTel: item.contactUserPhone || item.contactTel,
          contactName: item.contactUserName || item.contactName
        }
      })
    },

    handleShareSelectionChange(selection) {
      this.shareSelectionRow = selection.map(item => {
        return {
          companyId: item.supplierId || item.companyId,
          companyName: item.supplierName || item.companyName,
          contactTel: item.contactUserPhone || item.contactTel,
          contactName: item.contactUserName || item.contactName
        }
      })
    }
  }
}
</script>

<style scoped></style>
